import { render, staticRenderFns } from "./Surah.vue?vue&type=template&id=b7e8f1a2&"
import script from "./Surah.vue?vue&type=script&lang=js&"
export * from "./Surah.vue?vue&type=script&lang=js&"
import style0 from "./Surah.vue?vue&type=style&index=0&id=b7e8f1a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports